const firebaseErrorKeys = {
  "auth/admin-restricted-operation": "errors.adminRestricted",
  "auth/cancelled-popup-request": "errors.popupAlreadyOpen",
  "auth/email-already-in-use": "errors.emailInUse",
  "auth/invalid-credential": "errors.invalidCredential",
  "auth/invalid-email": "errors.invalidEmail",
  "auth/missing-email": "errors.missingEmail",
  "auth/missing-password": "errors.missingPassword",
  "auth/network-request-failed": "errors.network",
  "auth/operation-not-allowed": "errors.operationNotAllowed",
  "auth/popup-blocked": "errors.popupBlocked",
  "auth/popup-closed-by-user": "errors.popupClosed",
  "auth/requires-recent-login": "errors.recentLoginRequired",
  "auth/too-many-requests": "errors.tooManyRequests",
  "auth/user-disabled": "errors.userDisabled",
  "auth/user-not-found": "errors.userNotFound",
  "auth/weak-password": "errors.weakPassword",
  "auth/wrong-password": "errors.wrongPassword",
  "konvenio/no-manager-access": "login.googleNoManagerAccess",
  "firestore/cancelled": "errors.cancelled",
  "firestore/deadline-exceeded": "errors.timeout",
  "firestore/failed-precondition": "errors.failedPrecondition",
  "firestore/internal": "errors.default",
  "firestore/not-found": "errors.notFound",
  "firestore/permission-denied": "errors.permissionDenied",
  "firestore/resource-exhausted": "errors.resourceExhausted",
  "firestore/unavailable": "errors.serviceUnavailable",
  "storage/canceled": "errors.cancelled",
  "storage/object-not-found": "errors.fileNotFound",
  "storage/quota-exceeded": "errors.resourceExhausted",
  "storage/retry-limit-exceeded": "errors.timeout",
  "storage/unauthenticated": "errors.unauthenticated",
  "storage/unauthorized": "errors.permissionDenied",
  "storage/unknown": "errors.default",
};

function normalizeFirebaseCode(code) {
  if (!code) return "";
  if (firebaseErrorKeys[code]) return code;
  if (code.includes("/")) return code;
  return `firestore/${code}`;
}

export function getUserErrorMessage(error, fallbackKey = "errors.default", i18n) {
  const translator = i18n?.t ? i18n : null;
  const fallback = translator ? translator.t(fallbackKey) : "";
  const defaultMessage = translator ? translator.t("errors.default") : fallback;
  const code = normalizeFirebaseCode(error?.code);
  const messageKey = firebaseErrorKeys[code];

  if (translator && messageKey) {
    return translator.t(messageKey);
  }

  if (translator && fallbackKey) {
    return fallback || defaultMessage;
  }

  return error?.message || defaultMessage || "Something went wrong.";
}
